"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _superagent = _interopRequireDefault(require("superagent"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactModal = _interopRequireDefault(require("@homeaway/react-modal"));
var _reactButtons = require("@homeaway/react-buttons");
var _reactFormComponents = require("@homeaway/react-form-components");
var _reactGoogleRecaptcha = _interopRequireDefault(require("react-google-recaptcha"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); } /* eslint-disable complexity */
var Feedback = /*#__PURE__*/function (_Component) {
  function Feedback(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.state = {
      modalIsOpen: false,
      defaultFeedback: {
        label: "Feedback"
      },
      emailInput: {
        id: "emailFeedbackInput",
        label: "Email Address (Required)",
        contents: "",
        errorMsg: ""
      },
      firstNameInput: {
        id: "firstNameInput",
        label: "First Name (Required)",
        contents: "",
        errorMsg: ""
      },
      lastNameInput: {
        id: "lastNameInput",
        label: "Last Name (Required)",
        contents: "",
        errorMsg: ""
      },
      feedbackQuestions: [{
        id: "4386191",
        label: "General Feedback",
        contents: ""
      }, {
        id: "4386192",
        label: "Report Issues",
        contents: ""
      }],
      recaptchaToken: ""
    };
    _this.openModal = _this.openModal.bind(_this);
    _this.closeModal = _this.closeModal.bind(_this);
    _this.textAreaOnChange = _this.textAreaOnChange.bind(_this);
    _this.submitFeedback = _this.submitFeedback.bind(_this);
    _this.onRecaptchaChange = _this.onRecaptchaChange.bind(_this);
    return _this;
  }
  _inheritsLoose(Feedback, _Component);
  var _proto = Feedback.prototype;
  _proto.textFieldChange = function textFieldChange(type) {
    var _this2 = this;
    return function (event) {
      var _this2$setState;
      _this2.setState((_this2$setState = {}, _this2$setState["" + type] = _extends({}, _this2.state[type], {
        contents: event.target.value
      }), _this2$setState));
    };
  };
  _proto.textAreaOnChange = function textAreaOnChange(event) {
    var _event$target = event.target,
      id = _event$target.id,
      value = _event$target.value;
    var newState = {
      feedbackQuestions: [].concat(this.state.feedbackQuestions)
    };
    var targetIndex = newState.feedbackQuestions.findIndex(function (feedbackItem) {
      return feedbackItem.id === id;
    });
    newState.feedbackQuestions[targetIndex].contents = value;
    this.setState(newState);
  };
  _proto.openModal = function openModal(event) {
    if (event) {
      event.preventDefault();
    }
    this.setState({
      modalIsOpen: true
    });
  };
  _proto.closeModal = function closeModal() {
    this.setState({
      modalIsOpen: false
    });
  };
  _proto.isValidEmail = function isValidEmail(email) {
    return email && email.match(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/) !== null;
  };
  _proto.onRecaptchaChange = function onRecaptchaChange(token) {
    this.setState({
      recaptchaToken: token
    });
  };
  _proto.submitFeedback = function submitFeedback() {
    if (!this.isValidEmail(this.state.emailInput.contents)) {
      this.setState({
        emailInput: _extends({}, this.state.emailInput, {
          errorMsg: "Please enter a valid email address."
        })
      });
      return;
    }
    if (!this.state.firstNameInput.contents || this.state.firstNameInput.contents.trim() === "") {
      this.setState({
        firstNameInput: _extends({}, this.state.firstNameInput, {
          errorMsg: "First name is required."
        })
      });
      return;
    }
    if (!this.state.lastNameInput.contents || this.state.lastNameInput.contents.trim() === "") {
      this.setState({
        lastNameInput: _extends({}, this.state.lastNameInput, {
          errorMsg: "Last name is required."
        })
      });
      return;
    }
    this.setState({
      recaptchaCompleted: false
    });
    var referrer = this.props.feedback && this.props.feedback.referrer ? this.props.feedback.referrer : "";
    var requestParams = this.state.feedbackQuestions.reduce(function (accum, current, index) {
      accum["question" + (index + 1)] = current.id;
      accum["answer_" + current.id] = current.contents;
      return accum;
    }, {});
    var requestData = _extends({}, requestParams, {
      email_address: this.state.emailInput.contents,
      ccid: 104443,
      time1: 0,
      time2: 1000,
      prev: "direct_call",
      referer: "http://integration-central.homeaway.com" + referrer,
      width: 100,
      height: 200,
      comment_card: 1,
      ip_address_optout: 1,
      thank_you: null,
      gen3_serving_id: "ada1b25a-e185-4f87-8133-b4133159d7a7"
    });
    _superagent.default.post("https://gen3.opinionlab.com/v1/response/rate40.asp").type("form").send(requestData);
    var issue = this.state.feedbackQuestions.find(function (q) {
      return q.label === "Report Issues";
    }).contents;
    if (issue && issue.trim() !== "") {
      var data = {
        firstName: this.state.firstNameInput.contents,
        lastName: this.state.lastNameInput.contents,
        email: this.state.emailInput.contents,
        issueDesc: issue,
        crumb: window.ha && window.ha.crumb ? window.ha.crumb : "",
        recaptchaResponse: this.state.recaptchaToken
      };
      fetch(this.props.feedback.reportIssueUrl ? this.props.feedback.reportIssueUrl : "/t/api/reportIssue", {
        method: "POST",
        credentials: "include",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json;charset=UTF-8",
          "X-CSRF-Token": window.ha && window.ha.crumb
        },
        body: JSON.stringify(data)
      });
    }
    this.setState({
      modalIsOpen: false
    });
  };
  _proto.render = function render() {
    var _this3 = this;
    var _this$state = this.state,
      defaultFeedback = _this$state.defaultFeedback,
      modalIsOpen = _this$state.modalIsOpen,
      emailInput = _this$state.emailInput,
      feedbackQuestions = _this$state.feedbackQuestions,
      firstNameInput = _this$state.firstNameInput,
      lastNameInput = _this$state.lastNameInput;
    var feedback = this.props.feedback;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactModal.default, {
      id: "feedbackModal",
      title: "How can we improve?",
      onClose: this.closeModal,
      isOpen: modalIsOpen
    }, /*#__PURE__*/_react.default.createElement(_reactFormComponents.FormInput, {
      id: emailInput.id,
      label: emailInput.label,
      value: emailInput.contents,
      errorMsg: emailInput.errorMsg,
      onChange: this.textFieldChange("emailInput")
    }), /*#__PURE__*/_react.default.createElement(_reactFormComponents.FormInput, {
      id: firstNameInput.id,
      label: firstNameInput.label,
      value: firstNameInput.contents,
      errorMsg: firstNameInput.errorMsg,
      onChange: this.textFieldChange("firstNameInput")
    }), /*#__PURE__*/_react.default.createElement(_reactFormComponents.FormInput, {
      id: lastNameInput.id,
      label: lastNameInput.label,
      value: lastNameInput.contents,
      errorMsg: lastNameInput.errorMsg,
      onChange: this.textFieldChange("lastNameInput")
    }), feedbackQuestions.map(function (formItem) {
      return /*#__PURE__*/_react.default.createElement(_reactFormComponents.FormTextArea, {
        id: formItem.id,
        key: formItem.id,
        label: formItem.label,
        value: formItem.contents,
        onChange: _this3.textAreaOnChange
      });
    }), /*#__PURE__*/_react.default.createElement(_reactGoogleRecaptcha.default, {
      sitekey: "6LewK-cpAAAAALaMttz11VPT_s2BsI5rPTVptmT-",
      onChange: this.onRecaptchaChange
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "text-right"
    }, /*#__PURE__*/_react.default.createElement(_reactButtons.ButtonPrimary, {
      label: "Submit",
      role: "button",
      onClick: this.submitFeedback,
      disabled: !this.state.recaptchaToken
    }))), /*#__PURE__*/_react.default.createElement("a", {
      role: "button",
      className: "ic-login-logout-link",
      onClick: this.openModal
    }, feedback && feedback.label ? feedback.label : defaultFeedback.label));
  };
  return Feedback;
}(_react.Component);
/* eslint-disable no-undef */
Feedback.propTypes = {
  /** Enable feedback for ICHeader
   * 'label' - Text that viewer will see. Default value is 'Feedback'
   *  'referrer' - The text that will be prepended to any feedback sent by a user. Helps isolate origin of feedback.
   */
  feedback: _propTypes.default.shape({
    label: _propTypes.default.string,
    referrer: _propTypes.default.string,
    reportIssueUrl: _propTypes.default.string
  })
};
var _default = exports.default = Feedback;
//# sourceMappingURL=index.js.map